export type Role =
    | 'APP'
    | 'GATEWAY'
    | 'NEBULA'
    | 'BEACON'
    | 'VESSEL'
    | 'DEVELOPER'
    | 'THREAT_ANALYST'
    | 'CUSTOMER_ADMIN'
    | 'USER'

export type ExternalRole = 'CUSTOMER_ADMIN' | 'USER'

export const notSelectableRole = ['APP', 'GATEWAY', 'NEBULA', 'BEACON', 'VESSEL']

export const isUserAllowed = (userRoles: Role[] | undefined, rolesAllowed: Role[]): boolean => {
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    if (!userRoles || !rolesAllowed) {
        return false
    }

    return rolesAllowed.some((allowedRole: Role) => {
        return userRoles.some((userRole: Role) => userRole === allowedRole)
    })
}
